import { useCallback, useEffect, useState } from 'react';
const toText = (value, fractionDigits) => value == null ? '' : value.toFixed(fractionDigits);
/** Converts `MoneyTextInput`'s extracted text to a number, or null when empty. */
export const parseMoneyInputText = (text) => text === '' ? null : Number(text);
/**
 * Bridges numeric state to `MoneyTextInput`, whose `value` is the extracted
 * string. Typed text is kept as-is, so partial input such as "12.0" is not
 * reformatted; the text only resets when `value` changes from elsewhere.
 */
export const useMoneyInputText = (value, onChangeValue, fractionDigits = 2) => {
    const [text, setText] = useState(() => toText(value, fractionDigits));
    useEffect(() => {
        setText((current) => parseMoneyInputText(current) === (value ?? null)
            ? current
            : toText(value, fractionDigits));
    }, [value, fractionDigits]);
    const onChangeText = useCallback((_formatted, extracted = '') => {
        setText(extracted);
        onChangeValue(parseMoneyInputText(extracted));
    }, [onChangeValue]);
    return [text, onChangeText];
};
